import { useState } from 'react'

export const useGlobalStates = () => {

    const [showForm, setShowForm] = useState(false)
    const [modalOpeningMode, setModalOpeningMode] = useState('READONLY')
    const [activeTab, setActiveTab] = useState('MOVIMIENTOS')
    const [showMovementForm, setShowMovementForm] = useState(false)
    const [loadingSubmitForm, setLoadingSubmitForm] = useState(false)

    return Object.freeze({
        showForm, setShowForm,
        modalOpeningMode, setModalOpeningMode,
        activeTab, setActiveTab,
        showMovementForm, setShowMovementForm,
        loadingSubmitForm, setLoadingSubmitForm,
    })
}
